import { environment } from '@environments/environment';

export const APP_CONFIG = {
  version: environment.version,
  production: environment.production,
  name: environment.name,
  serviceBaseUrlMX: environment.serviceBaseUrlMX,
  serviceBaseUrl: environment.mocked ? environment.serviceMockedUrl : environment.serviceBaseUrl,
  externalServiceBaseUrl: environment.externalServiceBaseUrl,
  auth0: environment.auth0,
  externalUris: environment.externalUris,
  otherUris: environment.otherUris,
  amplitude: environment.amplitude,
  split: environment.split,
  dispersion: environment.dispersion,
};
